import { Injectable } from '@angular/core';
import { DrQueryParams, OpData } from '../base/base-service-with-bundle.service';
import { HttpServiceBundle } from '../base/http-service-bundle.service';
import { Observable } from 'rxjs';
import { CaseResultValues } from '../../../shared/models/case-result';
import {
    BaseHttpService,
    Create,
    Delete,
    Patch,
    UriBuilderParams
} from '../base/base-http.service';
import { Case } from '../../../shared/models/case';
import { BackendUriUnits } from '../base/backend-uri-units';


export class AdditionsResultsUriBuilderParams extends UriBuilderParams<CaseResultValues> {
    private readonly _case: string;

    get case() {
        return this._case;
    }

    constructor(caseX: Case | string, furtherResult?: CaseResultValues) {
        super(furtherResult);
        this._case = this.getParamId(caseX);
    }

    public buildUri(): string {
        let uri = `/${BackendUriUnits.CASES}/${this._case}`;
        uri += this.simpleUriBuild(`${BackendUriUnits.RESULT}/additions`);
        return uri;
    }
}

@Injectable({
    providedIn: 'root'
})
export class AdditionsResultService extends BaseHttpService<CaseResultValues, AdditionsResultsUriBuilderParams>
                           implements Create<CaseResultValues, AdditionsResultsUriBuilderParams>,
                                      Patch<CaseResultValues, AdditionsResultsUriBuilderParams>,
                                      Delete<CaseResultValues, AdditionsResultsUriBuilderParams> {

    constructor(httpServiceBundle: HttpServiceBundle) {
        super(CaseResultValues, httpServiceBundle);
    }

    public create(uriParams: AdditionsResultsUriBuilderParams, caseResultValues: CaseResultValues, params?: DrQueryParams): Observable<CaseResultValues> {
        return this.createBase(uriParams, caseResultValues, params);
    }

    public patch(uriParams: AdditionsResultsUriBuilderParams, data: OpData[], params?: DrQueryParams): Observable<CaseResultValues> {
        return this.patchBase(uriParams, data, params);
    }

    public patchAndUpdate(uriParams: AdditionsResultsUriBuilderParams, caseResultValues: CaseResultValues, data: OpData[], params?: DrQueryParams): Observable<CaseResultValues> {
        return this.patchAndUpdateBase(uriParams, caseResultValues, data, params, true);
    }

    public delete(uriParams: AdditionsResultsUriBuilderParams): Observable<boolean> {
        return this.deleteBase(uriParams);
    }
}
